import React, { useContext, useRef, useState } from 'react';
import { UseContext } from '../../../Context/Context';
import './Form.css'
import ItemList from './ItemList';
//import {useForm} from 'react-hook-form'
import List from './List';
import {default as api} from '../../../store/apiSlice'


const Form = () => {
    const {user} = useContext(UseContext)

    const [addTransaction] = api.useAddTransactionMutation()

   const submitForm= async (e)=>{
    e.preventDefault()

    const form= e.target
    const name = form.name.value
    const type = form.type.value
    const amount = form.price.value
    const date = form.date.value

  
    const item ={
        name : name,
        type : type,
        amount : amount,
        date : date,    
        user: user?.email,
      
    }
//console.log(item);
      if(!e) return {}
    await addTransaction(item).unwrap()
    form.reset()

     //console.log(item);
    // fetch(`http://localhost:5000/transactions`,{
    //           method: 'POST',
    //           headers: {
    //               'content-type': 'application/json'               
    //           },
    //           body: JSON.stringify(item)
    //       })
    //       .then(res=>res.json())
    //       .then(data=>{         
    //           if(data.acknowledged){
    //               alert('success')                                
    //           }
    //           else{
    //               console.log(data.message);
    //           }          
    //       })  
        //console.log(item);
   }


    return (
        <div className='form-history mb-6'>
           <form onSubmit={submitForm} className='form-section'>
                <input className='w-80' type="text" name='name' placeholder='Expense Description' required /> <br />
                <select className='w-80 p-2 m-2' name='type' required>
                    <option value="Investment" defaultValue>Investment</option>
                    <option value="Savings">Savings</option>
                    <option value="Expense">Expense</option>
                </select> <br />
                <input className='w-80' type="number" name='price' placeholder='Price' required /> <br />
                <input className='w-80' type="date" name='date'  /> <br />
                <button className='btn btn-sm mt-2 rounded-none btn-warning w-80 m-2'>Add</button>
            </form>
            <div className="history-section">
                <ItemList 
           
            />
            </div>
            
          
        </div>
    );
};

export default Form;